import React from 'react';
import PropTypes from 'prop-types';
export default function FooterBadges({
  children,
  ...props
}) {
  return /*#__PURE__*/React.createElement("div", props, children);
}
FooterBadges.propTypes = {
  children: PropTypes.node.isRequired
};
//# sourceMappingURL=badges.js.map